var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76465 5.41211L2.76465 4.97093C2.76465 2.77804 4.54234 1.00035 6.73523 1.00034V1.00034C8.92813 1.00034 10.7058 2.77804 10.7058 4.97093L10.7058 5.41211",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82324 9.8233V8.05859",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64746 9.8233V8.05859",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.01211C1 7.31505 1 6.46652 1.52721 5.93932C2.05442 5.41211 2.90294 5.41211 4.6 5.41211H8.87059C10.5676 5.41211 11.4162 5.41211 11.9434 5.93932C12.4706 6.46652 12.4706 7.31505 12.4706 9.01211V10.265C12.4706 12.8369 12.4706 14.1229 11.7337 14.9697C11.6427 15.0743 11.5445 15.1724 11.4399 15.2635C10.5931 16.0003 9.30718 16.0003 6.73529 16.0003V16.0003C4.16341 16.0003 2.87747 16.0003 2.03066 15.2635C1.92606 15.1724 1.8279 15.0743 1.73688 14.9697C1 14.1229 1 12.8369 1 10.2651V9.01211Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.35ddfbcb172c4e344ba475ba931ab68c.svg";
export { ForwardRef as ReactComponent };